export default __webpack_public_path__ + "static/media/web_screen_chat_ko.49fc52f4.png";